import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
import {
  InputAdornment,
  TextField,
  IconButton,
  Button,
  Container,
  Box,
  Paper,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Mail from "@material-ui/icons/Mail";
import { useHandling } from "../../context/HandleContext";
import { useAuth } from "../../context/AuthContext";
import { Column, Row } from "../utils/MaterialUIComponents";

const Signup = () => {
  const { signup, googleLogin } = useAuth();
  const { setError } = useHandling();
  const [showp, setshowp] = useState();
  const [showcp, setshowcp] = useState();
  const email = useRef();
  const password = useRef();
  const username = useRef();
  const cpassword = useRef();
  const get = (a) => a.current.value;
  const onSubmit = (e) => {
    e.preventDefault();
    if (get(password) === get(cpassword)) {
      signup(
        get(email),
        get(password),
        get(username),
        () => {},
        (e) => setError(e)
      );
    } else setError({ message: "Password Didn't match" });
  };
  return (
    <Container component={Box} my={3}>
      <Paper className="form w-100" style={{ width: `500px`, minWidth: 250 }}>
        <h1 className="mt-2 mb-3">Welcome !</h1>
        <div className="mb-3">
          {/* <Button
            color="secondary"
            variant="contained"
            startIcon={<Mail />}
            onClick={() => googleLogin(() => {}, setError)}
          >
            Signup With Google
          </Button> */}
        </div>
        <Row
          component="form"
          onSubmit={onSubmit}
          className="row justify-content-center"
        >
          <Column xs={6}>
            <TextField
              label="Email"
              className="w-100"
              inputRef={email}
              required
              id="email"
              type="email"
            />
          </Column>
          <Column xs={6}>
            <TextField
              label="Username"
              className="w-100"
              inputRef={username}
              required
              id="username"
              type="text"
            />
          </Column>
          <Column xs={6}>
            <TextField
              required
              id="password"
              label="Password"
              type={showp ? "text" : "password"}
              className="w-100"
              inputRef={password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setshowp((a) => !a)}>
                      {showp ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Column>
          <Column xs={6}>
            <TextField
              required
              id="cp"
              label="Confirm Password"
              type={showcp ? "text" : "password"}
              className="w-100"
              inputRef={cpassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setshowcp((a) => !a)}>
                      {showcp ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Column>
          <Box>
            <Button variant="contained" color="primary" type="submit">
              Signup
            </Button>
            <p className="mt-2">
              Back to{" "}
              <Link to="/login" className="text-primary text-decoration-none">
                Login
              </Link>
            </p>
          </Box>
        </Row>
      </Paper>
    </Container>
  );
};

export default Signup;
